import isValue from '@glass/common/modules/utils/isValue';

const required = (value) => (isValue(value) ? undefined : 'Required');

export default required;
